// extracted by mini-css-extract-plugin
export default {"agreementlinkscontainer":"agreementlinks_agreementlinkscontainer__i33af"};